/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/edit/extrude 层；
 * 2. 负责提供拉伸切除的会话桥接子类；
 * 3. 公共桥接逻辑复用拉伸族桥接基类，本类只固定 cut 语义配置。
 */

import { ExtrudeFeatureSessionBridge } from './ExtrudeFeatureSessionBridge';

/**
 * 拉伸切除会话桥接层。
 */
export class CutExtrudeFeatureSessionBridge extends ExtrudeFeatureSessionBridge {
    /**
     * 构造拉伸切除桥接层。
     */
    public constructor() {
        super({
            featureKind: 'cut-extrude',
            operation: 'cut',
        });
    }
}
